<template>
    <div class="filter-items" v-if="filterData != null">
        <div class="filter-item filter-room">
            <h3>{{flatsWords.flats_filters_names.room}}</h3>
            <div class="filter room-items">
                <div class="item-R" v-for="item in salesCard.filter_set_room" @click="e => e.target.classList.toggle('active')">
                    <input type="checkbox" :id="'room_' + item.number" :value="item.number" v-model="filterData.roomQuantities">
                    <label :for="'room_' + item.number" @click="setUpDataClick" :class="{'active' : getActiveClass(item)}">{{item.number}}</label>
                </div>
            </div>
        </div>
        <div class="filter-item filter-floor">
            <h3>{{flatsWords.flats_filters_names.floor}}</h3>
            <div class="filter" id="FloorFilter">
                <input type="text" id="floor-filter" name="floor"  class="ionRangeSlider" value="" />
            </div>
        </div>
        <div class="filter-item filter-size">
            <h3>{{flatsWords.flats_filters_names.size}} <span>м²</span></h3>
            <div class="filter" id="SizeFilter">
                <input type="text" id="size-filter" name="size"  class="ionRangeSlider" value="" />
            </div>
        </div>
        <div class="filter-item filter-price" v-if="salesCard.site_shablon_price_init == 'true'">
            <h3>{{flatsWords.flats_filters_names.price}} <span>тг. м²</span></h3>
            <div class="filter" id="PriceFilter">
                <input type="text" id="price-filter" name="price"  class="ionRangeSlider" value="" />
            </div>
        </div>
        <div class="filter-item filter-btn-mobile">
            <a href="#" @click.prevent="closeFilterMobile" 
                v-scroll-to="{
                    el: '.flats-crm-topbar',
                    offset: -75
                }">
                <span>ПОКАЗАТЬ ПЛАНИРОВКИ</span>
            </a>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-flats-filter',
        components: {
        },
        data () {
            return {
                filterData: null,
                FloorFilter: null,
                SizeFilter: null,
                PriceFilter: null,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            flatsWords: 'loadFlatsWords',
            paginPageNumber: 'loadPaginPageNumber',
            resetModeTrigger: 'loadResetTriggerMove',
            flatsPagintaion: 'loadFlatsPagination',
            flatsFilterData: 'loadFlatsFilterData',
        }),
        methods: {
            setUpDataClick() {
                this.flatsFilterData.pageNumber = 1;
                setTimeout(() => {
                    this.getItemsFlatsByFilter();
                }, 300);
            },
            setFilterDataBase() {
                this.filterData = {
                    complexCodes: null,
                    roomQuantities: [],
                    areaFrom: this.salesCard.filter_set_size.min,
                    areaTo: this.salesCard.filter_set_size.max,
                    floorRangeStart: this.salesCard.filter_set_floor.min,
                    floorRangeEnd: this.salesCard.filter_set_floor.max,
                    meterPriceFrom: this.salesCard.filter_set_money.min,
                    meterPriceTo: this.salesCard.filter_set_money.max,
                    linesOnPage:8,
                    pageNumber: 1,
                    // notFirstFloor: "false",
                };
                if (window.host != 'lmgold') {
                    this.filterData.complexCodes = [this.salesCard.crm_code];
                } else {
                    this.filterData.complexCodes = ['LDM-3', 'LDM-V', 'LDM-VI'];
                }
                this.$store.commit('setFlatsFilterData', this.filterData);
            },
            getItemsFlatsByFilter() {
                // console.log('getData')
                // this.$store.dispatch('getFlatsByFilter', this.filterData);
                this.$store.commit('UpdatePaginPageNumber', 1);
                // this.$store.commit('setFlatsFilterData', this.flatsFilterData);
                this.$store.dispatch('getFlatsByFilter', this.flatsFilterData);
                this.$store.dispatch('getFlatsPagintationCounters', this.flatsFilterData);
            },
            getActiveClass(elem) {
                // console.log(elem);
                var data = this.flatsFilterData.roomQuantities;
                var filter = data.filter(item => {
                    return item == elem.number
                });
                // console.log(filter);
                if (filter.length > 0)
                return true;
                
            },
            BuildIonRangeSlider() {
                var _self = this;
                _self.FloorFilter = $("#floor-filter");
                _self.SizeFilter = $('#size-filter');
                _self.PriceFilter = $('#price-filter');
                
                _self.FloorFilter.ionRangeSlider({
                    type: "double",
                    min: _self.salesCard.filter_set_floor.min,
                    max: _self.salesCard.filter_set_floor.max,
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.flatsFilterData.floorRangeStart = data.from;
                        _self.flatsFilterData.floorRangeEnd = data.to;
                        _self.flatsFilterData.pageNumber = 1;
                        // _self.updateFilterDataBase();
                        console.log(_self.flatsFilterData, 'TEST')
                        _self.getItemsFlatsByFilter();
                    },
                });
                _self.SizeFilter.ionRangeSlider({
                    type: "double",
                    min: _self.salesCard.filter_set_size.min,
                    max: _self.salesCard.filter_set_size.max,
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.flatsFilterData.areaFrom = data.from;
                        _self.flatsFilterData.areaTo = data.to;
                        _self.flatsFilterData.pageNumber = 1;
                        // _self.updateFilterDataBase();
                        _self.getItemsFlatsByFilter();
                    },
                });
                _self.PriceFilter.ionRangeSlider({
                    type: "double",
                    min: _self.salesCard.filter_set_money.min,
                    max: _self.salesCard.filter_set_money.max,
                    step: 1000,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.flatsFilterData.meterPriceFrom = data.from;
                        _self.flatsFilterData.meterPriceTo = data.to;
                        _self.flatsFilterData.pageNumber = 1;
                        // _self.updateFilterDataBase();
                        _self.getItemsFlatsByFilter();
                    },
                });
            },
            closeFilterMobile() {
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
				this.$store.commit('SetVisibleFilterMobile', false);
            }
            
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.setFilterDataBase();
            setTimeout(() => {
                this.BuildIonRangeSlider();
            }, 300);
            this.$store.watch(
                (state) => state.FilterResetTrigger,
                (newValue) => {
                    if (newValue) {
                        // console.log(this.resetModeTrigger, 'update');
                        let floorFilter = $("#floor-filter").data("ionRangeSlider");
                        let sizeFilter = $("#size-filter").data("ionRangeSlider");
                        let priceFilter = $("#price-filter").data("ionRangeSlider");
                        this.flatsFilterData.roomQuantities = [];
                        floorFilter.reset();
                        sizeFilter.reset();
                        priceFilter.reset();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-filter.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-filter-respond.scss';
</style>